"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridRow = exports.GridContainer = exports.GridCol = exports.Grid = void 0;
const GridCol_1 = __importDefault(require("./GridCol"));
exports.GridCol = GridCol_1.default;
const GridContainer_1 = __importDefault(require("./GridContainer"));
exports.GridContainer = GridContainer_1.default;
const GridRow_1 = __importDefault(require("./GridRow"));
exports.GridRow = GridRow_1.default;
const Grid = Object.assign(GridContainer_1.default, { Col: GridCol_1.default, Row: GridRow_1.default });
exports.Grid = Grid;
